import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dc6daa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-top-container" }
const _hoisted_2 = { class: "home-top-header-container" }
const _hoisted_3 = { class: "home-top-logo-container" }
const _hoisted_4 = { class: "home-top-title animate__animated animate__zoomIn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-top-right-aside" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeLogo = _resolveComponent("HomeLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_HomeLogo, { class: "home-top-logo" })
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.top.title1")), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.top.title2")), 1)
      ])
    ]),
    _hoisted_5
  ]))
}